const categories: { id: string; name: string }[] = [
  {
    id: "fashionDisabled",
    name: "Fashion"
  },
  {
    id: "sportDisabled",
    name: "Sport"
  },
  {
    id: "livingDisabled",
    name: "Living"
  },
  {
    id: "electronicsDisabled",
    name: "Electronics"
  }
];
export default categories;
